// SLIDER INFINITO - patch
(function(){
var t=document.getElementById('avRevTrack');
if(!t)return;
var orig=Array.from(t.querySelectorAll('.av-rev-card'));
var N=orig.length;if(!N)return;
var g=10,c=0;
function pv(){return window.innerWidth<480?1:window.innerWidth<768?2:window.innerWidth<1100?4:5;}
function cw(){var p=pv();return(t.parentElement.offsetWidth-(p-1)*g)/p;}
function setup(){
 t.innerHTML='';
 orig.forEach(function(x){t.appendChild(x.cloneNode(true));});
 orig.forEach(function(x){t.appendChild(x.cloneNode(true));});
 orig.forEach(function(x){t.appendChild(x.cloneNode(true));});
 c=N;sp(false);bd();
}
function sp(a){
 t.style.transition=a?'transform .4s cubic-bezier(.4,0,.2,1)':'none';
 t.style.transform='translateX(-'+(c*(cw()+g))+'px)';
}
var dotsEl=document.getElementById('avRevDots');
function bd(){
 if(!dotsEl)return;
 dotsEl.innerHTML='';
 for(var i=0;i<N;i++){(function(i){
  var d=document.createElement('span');
  d.className='av-rev-dot'+(i===0?' active':'');
  d.addEventListener('click',function(){sl(N+i);});
  dotsEl.appendChild(d);
 })(i);}
 ud();
}
function ud(){
 var r=(c%N+N)%N;
 document.querySelectorAll('.av-rev-dot').forEach(function(d,i){d.classList.toggle('active',i===r);});
}
function sl(idx){
 c=idx;sp(true);ud();
 setTimeout(function(){
  if(c>=N*2){c-=N;sp(false);}
  else if(c<N){c+=N;sp(false);}
 },420);
}
var prev=document.getElementById('avRevPrev');
var next=document.getElementById('avRevNext');
if(prev)prev.onclick=function(){sl(c-1);};
if(next)next.onclick=function(){sl(c+1);};
var sx=0;
t.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
t.addEventListener('touchend',function(e){var dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>50)sl(dx<0?c+1:c-1);},{passive:true});
window.addEventListener('resize',function(){setup();});
setup();
})();
